/* eslint-disable jsx-quotes */
import React, { Component } from 'react'

import TimePollCard from '../TimePollCard/TimePollCard'
import moment from 'moment'
import { routerActions } from 'react-router-redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import noPollsBackground from 'assets/no-polls-background.png'

import {
  eventTokenSelector,
  pollsListSelector,
  userSelector,
  signUpListSelector
} from 'src/selectors'

import styles from './time-poll-list.scss'
class TimePollList extends Component {
  _onChangeTab(tab) {
    const { onChangeRoute } = this.props
    let destinationUrl = `/tp/`
    onChangeRoute(destinationUrl + tab)
  }

  _mapPolls() {
    const { pollList, signUpList, type } = this.props
    let dataList = []
    if (type === 'tp') {
      dataList = pollList
    } else {
      dataList = signUpList
    }

    const pollsDetailsStatusSort = dataList.sort((a, b) => {
      if (a.status === 'active' && (b.status === 'closed' || !b.status)) {
        return -1
      }
      if ((a.status === 'closed' || !a.status) && b.status === 'active') {
        return 1
      }
      return 0
    })

    const pollsDetailsDateSort = pollsDetailsStatusSort.sort((a, b) => {
      if (a.status === 'active' && b.status === 'active') {
        if (moment(a.created_at).isBefore(b.created_at)) {
          return -1
        }
        return 1
      }
      if ((a.status === 'closed' || !a.status) && (b.status === 'closed' || !b.status)) {
        if (moment(a.created_at).isBefore(b.created_at)) {
          return -1
        }
        return 1
      }
      return 0
    })

    return pollsDetailsDateSort
  }

  render() {
    const { user, type } = this.props
    const pollDetails = this._mapPolls()
    if (pollDetails.length > 0) {
      return (
        <div className={styles['polls-wrapper']}>
          {pollDetails.map((poll, index) => {
            return <TimePollCard type={type} key={index} poll={poll} user={user} />
          })}
        </div>
      )
    } else {
      return (
        <div className={styles['no-polls-container']}>
          <div className={styles['no-polls-wrapper']}>
            <img src={noPollsBackground} alt="" />
            <span className={styles['no-polls-title']}>no polls</span>
            <span className={styles['no-polls-info']}>
              You'll see all your time polls here. Get started on your next polls now!
            </span>
          </div>
        </div>
      )
    }
  }
}

TimePollList.defaultProps = {
  type: 'tp'
}

TimePollList.propTypes = {
  onChangeRoute: PropTypes.func,
  user: PropTypes.object,
  pollList: PropTypes.array,
  signUpList: PropTypes.array,
  type: PropTypes.string
}

function mapStateToProps(state) {
  return {
    eventToken: eventTokenSelector(state),
    pollList: pollsListSelector(state),
    user: userSelector(state),
    signUpList: signUpListSelector(state)
  }
}
function mapDispatchToProps(dispatch) {
  return {
    onChangeRoute: route => {
      dispatch(routerActions.replace(route))
      window.scrollTo(0, 0)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimePollList)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/TimePoll/TimePollList/TimePollList.jsx